import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import useApis from "../../services/useAPI";
import { ErrorDisplay } from "../Errors/ErrorDisplay";
import { blockedKitError } from "../../utils/constants";

export default function ResumeActivateBlood() {
  const { test_kit_id } = useParams();
  const [redirect, setRedirect] = useState();

  // API hook
  const { callApi, resultGet, serverError } = useApis();

  useEffect(() => {
    localStorage.setItem("test_id", test_kit_id)
    callApi(
      null,
      `/api/dashboard/sample-collection/resume/${test_kit_id}`,
      "GET"
    );

  }, []);

  useEffect(() => {
    if (resultGet) {
      const { activation_stage, barcode, secondary_type, secondary_barcode } = resultGet;

      // Navigates based on the activation stage received from the API response
      switch (activation_stage) {
        case "barcode":
          if (secondary_barcode !== null && barcode !== null) {
            localStorage.setItem("secondary_barcode_id", secondary_barcode)
            setRedirect(`/secondary-barcode/${barcode}`);
          } else {
            setRedirect(`/confirm-details/${barcode || secondary_barcode}/`);
          }
          break;
        case "secondary-barcode":
          setRedirect(`/confirm-details/${barcode || secondary_barcode}/`);
          break;
        case "confirm-barcode":
          setRedirect(`/secondary-barcode/${barcode}`);
          break;
        case "consent":
          setRedirect(`/confirm-details/${barcode || secondary_barcode}/`);
          break;
        case "personal-details":
          if (barcode?.startsWith("C") || barcode?.startsWith("BT")) {
            setRedirect(`/wellness-collect-sample/${barcode || secondary_barcode}`);
          } else if (secondary_type === "urine") {
            setRedirect(`/sh-consent/${barcode || secondary_barcode}`);
          } else if (barcode?.startsWith('B') || barcode?.startsWith("BT")) {
            setRedirect(`/time-administered/${barcode || secondary_barcode}/`);
          }
          else {
            setRedirect(`/time-administered/${barcode || secondary_barcode}/`);
          }
          break;
        case "sh-consent":
          setRedirect(`/time-administered/${barcode || secondary_barcode}/`);
          break;
        case "collect-sample":
          setRedirect(`/time-administered/${barcode || secondary_barcode}/`);
          break;
        case "test-taken":
          setRedirect(`/assessment/${test_kit_id}/1`);
          break;
      }
    }
  }, [resultGet])
  // Shows error message if any
  if (serverError === blockedKitError) {
    return <ErrorDisplay error={serverError} consent={false} />;
  }
  if (serverError) {
    return <div className="alert alert-danger">Error: {serverError}</div>;
  }

  return redirect && <Navigate to={redirect} />;
}
